import "./LayoutNavSide.css";
import React from "react";
import SideBar from "./SideBar/SideBar";
import NavBar from "./navbar/NavBar";
import { Outlet } from "react-router-dom";


function LayoutNavSide() {
  return (
    <div className="layout-nav-side position-relative ">
      <NavBar/>
      <div className="d-flex align-items-center">
        <div className="flex-shrink-0 mt-0">
          <SideBar />
        </div>
        <div className="flex-grow-1 ms-3 lNS-droit">
          <Outlet />
        </div>
      </div>
    
    </div>
  );
};

export default LayoutNavSide


